import type { CSSObject, DrawerProps, Theme } from '@mui/material';
import { drawerClasses, styled } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import type { PropsWithChildren } from 'react';

const OPEN_DRAWER_WIDTH = 248;
const CLOSE_DRAWER_WIDTH = 72;

const openedMixin = (theme: Theme): CSSObject => ({
  width: OPEN_DRAWER_WIDTH,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  backgroundColor: theme.palette.common.black,
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: theme.palette.common.black,
  overflowX: 'hidden',
  width: CLOSE_DRAWER_WIDTH,
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: OPEN_DRAWER_WIDTH,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      [`& .${drawerClasses.paper}`]: openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      [`& .${drawerClasses.paper}`]: closedMixin(theme),
    }),
  }),
);

export const NavbarDrawer: React.FC<PropsWithChildren<DrawerProps>> = ({ children, ...props }) => {
  return (
    <Drawer {...props}>
      {children}
    </Drawer>
  );
};